import { Form, Formik, FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

import { QuestionWrapper } from '../../components';
import { CheckBoxField, CheckBoxGroupField } from '../../fields';
import { ClientStatementFormValues } from '../../models/Forms';
import { I18nNameSpaces } from '../../services/i18n';
import { makeClientStatementSchema } from './schema';

interface Props {
  initialValues?: Partial<ClientStatementFormValues>;
  onSubmit: (values: ClientStatementFormValues) => void;
  bindSubmit?: (formik: FormikProps<ClientStatementFormValues>) => void;
}

export default function ClientStatementForm({ onSubmit, initialValues, bindSubmit }: Props) {
  const { t } = useTranslation(I18nNameSpaces.Forms);
  const schema = makeClientStatementSchema(t);

  function handleOnSubmit(values: ClientStatementFormValues) {
    onSubmit && onSubmit(values);
  }

  function renderForm(formik: FormikProps<ClientStatementFormValues>) {
    if (bindSubmit) {
      bindSubmit(formik);
    }
    return (
      <div className="company-form">
        <Form>
          <QuestionWrapper>
            <QuestionWrapper.Divider>
              <CheckBoxField name="a" label={t('clientStatementForm.a.label')} />
            </QuestionWrapper.Divider>
            <QuestionWrapper.Divider>
              <QuestionWrapper.Title>{t('clientStatementForm.b.label')}</QuestionWrapper.Title>
              <CheckBoxGroupField
                name="b"
                type="vertical"
                options={[
                  {
                    label: t('clientStatementForm.b.options.a'),
                    value: 'a',
                  },
                  {
                    label: t('clientStatementForm.b.options.b'),
                    value: 'b',
                  },
                  {
                    label: t('clientStatementForm.b.options.c'),
                    value: 'c',
                  },
                  {
                    label: t('clientStatementForm.b.options.d'),
                    value: 'd',

                    custom: true,
                  },
                ]}
              />
            </QuestionWrapper.Divider>
          </QuestionWrapper>
        </Form>
      </div>
    );
  }

  return (
    <Formik<ClientStatementFormValues>
      initialValues={{
        a: initialValues?.a,
        b: initialValues?.b ?? [],
      }}
      onSubmit={handleOnSubmit}
      validationSchema={schema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {renderForm}
    </Formik>
  );
}
